import React from "react";
import NotFoundSegment from "./NotFoundSegment";

const NotFound = () => {
    return (
        <NotFoundSegment/>
    )
};

export default NotFound;